/**
 * Payment Method Dropdown Component
 * Single-select dropdown for card type / payment method filter
 * Matches Flutter's paymentMethodSubject pattern
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/core/components/ui/select';
import { Label } from '@/core/components/ui/label';
import {
  CardType,
  CardTypeLabels,
  type CardTypeValue,
} from '../../types/filter-enums';

interface PaymentMethodDropdownProps {
  value: CardTypeValue | undefined;
  onChange: (value: CardTypeValue | undefined) => void;
  onAutoRefresh?: () => void;  // Callback for auto-refresh on change
  className?: string;
}

export function PaymentMethodDropdown({
  value,
  onChange,
  onAutoRefresh,
  className = '',
}: PaymentMethodDropdownProps) {
  const handleChange = (newValue: string) => {
    if (newValue === 'all') {
      onChange(undefined);
    } else {
      onChange(newValue as CardTypeValue);
    }
    // Trigger auto-refresh when selection changes
    if (onAutoRefresh) {
      onAutoRefresh();
    }
  };

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <Label className="text-xs text-muted-foreground">Payment Method</Label>
      <Select value={value || 'all'} onValueChange={handleChange}>
        <SelectTrigger className="h-8 text-sm placeholder:text-gray-400">
          <SelectValue placeholder="All" className="placeholder:text-gray-400" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          {Object.entries(CardType).map(([key, enumValue]) => (
            <SelectItem key={enumValue} value={enumValue}>
              {CardTypeLabels[enumValue]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
